import { useContextState } from "../../hooks/theme"

const useDetailTypeOfResponse = () => {
    const { colors } = useContextState()

    return ({
        optionsContainer: {
            cursor: 'default',
            '& .MuiFormControlLabel-root': {
                alignItems: 'start',
                width: '100%',
                marginLeft: 0,
            },
            '& .MuiFormControlLabel-label': {
                cursor: 'default',
                wordBreak: "break-word",
                lineHeight: 1,
            },
            '& .MuiButtonBase-root:hover': {
                cursor: 'default',
                backgroundColor: 'transparent',
            },
            '& .MuiTypography-root': {
                fontSize: '14px',
                color: colors.color13,
            },
            '& .MuiCheckbox-root': {
                padding: '2px',
                cursor: 'default',
                '& .MuiBox-root': {
                    width: '17px',
                    height: '17px',
                    marginRight: '10px',
                },
            },
            '& .MuiRadio-root': {
                padding: '2px',
                cursor: 'default',
                '& .MuiBox-root': {
                    width: '17px',
                    height: '17px',
                },
            },
        },
        iconContainer: {
            display: 'flex',
            gap: '10px',
            alignItems: 'start',
            width: '100%'
        },
        icon: {
            width: '30px'
        },
        free: {
            fontSize: '14px',
            fontWeight: '500',
            color: colors.color10,
        }
    })
}

export { useDetailTypeOfResponse }